"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/layout/index.vue"));
var _notificationsSubMenu = require("./subMenus/marketing/notifications-sub-menu");
const marketingRouter = {
  path: '/marketing',
  component: _index.default,
  redirect: 'noredirect',
  name: 'Marketing',
  meta: {
    title: 'marketing.title',
    icon: 'marketing'
  },
  children: [..._notificationsSubMenu.notificationSubMenu]
};
var _default = exports.default = marketingRouter;